module.exports = __webpack_public_path__ + "static/img/iphone4.6c107fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone4.png
// module id = d7fm
// module chunks = 0